<template>
  <el-table ref="singleTable" :data="allData" :max-height="tableHeight-40" stripe style="width: 100%">
        <el-table-column width="50" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{scope.$index+index+1}}</span>
          </template>
        </el-table-column>
    <el-table-column property="roadcode" label="道路编码" align="center"></el-table-column>
    <el-table-column property="provname" label="省份" align="center"></el-table-column>
    <el-table-column property="cityname" label="城市" align="center"></el-table-column>
    <el-table-column property="adminname" label="区县" align="center"></el-table-column>
    <el-table-column property="name" label="站点名称" align="center"></el-table-column>
    <el-table-column property="stationTypeName" label="站点类型" align="center"></el-table-column>
    <el-table-column property="kind" label="站点品牌" align="center"></el-table-column>
    <el-table-column property="" label="经纬度" align="center">
      <template slot-scope="scope">
        <span>{{scope.row.displayX+','+scope.row.displayY}}</span>
      </template>
    </el-table-column>
    <el-table-column property="address" label="地理位置描述" align="center"></el-table-column>
    <el-table-column property="flowCount" label="站前流量(次)" align="center"></el-table-column>
    <el-table-column property="stopCount" label="站内停靠(次)" align="center"></el-table-column>
    <el-table-column property="entrRateFormat" label="进站率(%)" align="center"></el-table-column>
  </el-table>
</template>
<script>
import { format } from './util'
import nameMixin from './nameMixin'
import Util from "utils/util";

export default {
  mixins: [nameMixin],
  props: {
    allData: {
      type: Array,
    },
    index: {
      type: Number,
    },
    toDetail: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      format,
      zhanDianOption: Util.zhanDianOption,
    }
  },
  methods: {}
}
</script>
